import { useEffect, useState } from "react";
import { ChartCard, Skeleton } from "@/components/reusable";
import { fetchDeductibleStructure } from "@/services/analyticsApi";
import { useAnalyticsFilters } from "@/hooks/useAnalyticsFilters";
import type { DeductibleRow } from "@/types/analytics";

export function DeductibleStructure() {
  const filters = useAnalyticsFilters();
  const [rows, setRows] = useState<DeductibleRow[] | null>(null);

  useEffect(() => {
    let active = true;
    setRows(null);
    fetchDeductibleStructure(filters).then((r) => {
      if (active) setRows(r);
    });
    return () => {
      active = false;
    };
  }, [filters]);

  return (
    <ChartCard
      title="Deductible structure"
      subtitle="Peril code coverage across fleet · vessel count & SI range"
    >
      {!rows ? (
        <div className="flex flex-col gap-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} height="h-3" />
          ))}
        </div>
      ) : (
        <ul>
          {rows.map((r, idx) => {
            const isFlag = r.needsReview;
            const divider = isFlag ? "border-t border-[var(--color-border)] mt-1 pt-3" : "";
            return (
              <li
                key={r.peril}
                className={`flex items-center gap-3 py-[7px] border-b border-[var(--color-border-light)] last:border-b-0 text-[12px] ${idx === rows.length - 1 && isFlag ? divider : ""}`}
              >
                <span
                  className={`flex-1 ${isFlag ? "text-[var(--color-text-tertiary)]" : "text-[var(--color-text-primary)]"}`}
                >
                  {r.peril}
                </span>
                <span
                  className={`text-[11px] min-w-[60px] text-right ${isFlag ? "text-[var(--color-error)] font-semibold" : "text-[var(--color-text-tertiary)]"}`}
                >
                  {r.vesselCount} vessels
                </span>
                {isFlag ? (
                  <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full uppercase tracking-wide bg-[var(--color-warning-light)] text-[#854F0B] min-w-[80px] text-center">
                    Needs review
                  </span>
                ) : (
                  <span
                    className="text-[10px] text-[var(--color-text-secondary)] min-w-[80px] text-right"
                    style={{ fontFamily: "var(--font-mono)" }}
                  >
                    {r.range}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </ChartCard>
  );
}
